import { render, staticRenderFns } from "./ModalRecipeIngredient.vue?vue&type=template&id=10d22f77"
import script from "./ModalRecipeIngredient.vue?vue&type=script&lang=js"
export * from "./ModalRecipeIngredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports